export class Gacha<T = unknown> {
    private entries: Array<{ item: T; accumulatedWeight: number }> = [];
    private totalWeight = 0;

    /**
     * Add an item with a given weight.
     * Higher weight = higher probability of being drawn.
     * @param item Item to add.
     * @param weight Relative weight.
     */
    addEntries(item: T, weight: number): void {
        this.totalWeight += weight;
        this.entries.push({ item, accumulatedWeight: this.totalWeight });
    }

    /**
     * Draw a random item, weighted by the entries added.
     * Returns undefined if no entries have been added.
     */
    getRandom(): T | undefined {
        const r = Math.random() * this.totalWeight;
        return this.entries.find((e) => e.accumulatedWeight >= r)?.item;
    }
}
